/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StressAreaGroupDto } from '../../models/stress-area-group-dto';

export interface GetStressAreaGroup$Params {
  id: string;

/**
 * Get terser output with fewer fields filled in
 */
  terse?: boolean;
}

export function getStressAreaGroup(http: HttpClient, rootUrl: string, params: GetStressAreaGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<StressAreaGroupDto>> {
  const rb = new RequestBuilder(rootUrl, getStressAreaGroup.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('terse', params.terse, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StressAreaGroupDto>;
    })
  );
}

getStressAreaGroup.PATH = '/v1/stressareagroup/{id}';
